// components/MessageContent.tsx
import React from "react";
import { Message } from "../../interfaces";
import PlaceholderReplacer from "../outbound/templates/placeholder";
import TimeStamps from "./timestamps";
import InteractiveContent from "./interactive-content";

interface Props {
  message: Message;
  type: "conversation" | "playground" | "web-chat" | "debug" | string;
  mode?: String;
  scrollToBottom?: (value: number) => void;
  openMedia?: (message: Message) => void;
}

const MessageContent: React.FC<Props> = ({
  message,
  type,
  mode,
  scrollToBottom,
  openMedia,
}) => {
  const { content, interactive } = message;
  const { flag, data } = interactive;
  const body = flag ? data?.body || content : content;
  const footer = flag ? data?.footer || "" : "";
  return (
    <>
      {message?.interactive?.flag && message?.interactive?.data?.header && (
        <InteractiveContent
          content={message.interactive.data}
          mode={mode}
          scrollToBottom={scrollToBottom}
          openMedia={() => openMedia?.(message)}
          isSentMessage={message.right}
        />
      )}

      <PlaceholderReplacer template={body} placeholders={[]} />
      <TimeStamps message={message} type={type} />
      {footer && <span className="chat-footer">{footer}</span>}
    </>
  );
};

export default MessageContent;
